module.exports = __webpack_public_path__ + "img/reset-step-two3.f75185bb.png";